import { create } from 'zustand';

type ThreeDModelLoadingStore = {
  loadingCounts: Map<string, number>;
  generation: number;
  beginKeysLoading: (keys: string[]) => void;
  endKeysLoading: (keys: string[], generation: number) => void;
  reset: () => void;
};

export const useThreeDModelLoadingStore = create<ThreeDModelLoadingStore>((set) => ({
  loadingCounts: new Map(),
  generation: 0,
  beginKeysLoading: (keys) =>
    set((state) => {
      if (keys.length === 0) {
        return state;
      }
      const loadingCounts = new Map(state.loadingCounts);
      for (const key of keys) {
        loadingCounts.set(key, (loadingCounts.get(key) ?? 0) + 1);
      }
      return { loadingCounts };
    }),
  endKeysLoading: (keys, generation) =>
    set((state) => {
      if (keys.length === 0 || generation !== state.generation) {
        return state;
      }
      const loadingCounts = new Map(state.loadingCounts);
      for (const key of keys) {
        const next = (loadingCounts.get(key) ?? 0) - 1;
        if (next > 0) {
          loadingCounts.set(key, next);
        } else {
          loadingCounts.delete(key);
        }
      }
      return { loadingCounts };
    }),
  reset: () => set((state) => ({ loadingCounts: new Map(), generation: state.generation + 1 })),
}));

export function beginThreeDModelKeysLoading(keys: string[]): number {
  const store = useThreeDModelLoadingStore.getState();
  store.beginKeysLoading(keys);
  return store.generation;
}

export function endThreeDModelKeysLoading(keys: string[], generation: number) {
  useThreeDModelLoadingStore.getState().endKeysLoading(keys, generation);
}

export function resetThreeDModelLoading() {
  useThreeDModelLoadingStore.getState().reset();
}

export function useIsThreeDModelLoading(key: string | undefined): boolean {
  return useThreeDModelLoadingStore((state) => key !== undefined && (state.loadingCounts.get(key) ?? 0) > 0);
}
